import React from "react";
import { GripVertical, Plus } from "lucide-react";
import { useFaqStore } from "src/store/faqStore";

export const FaqCategoriesToolbar: React.FC = () => {
  const categoryCount = useFaqStore((s) => s.form?.faq.length ?? 0);
  const canManage = useFaqStore((s) => s.canManage);
  const addSection = useFaqStore((s) => s.addSection);

  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-sm font-bold text-white/75">
        <span className="font-extrabold text-white">{categoryCount}</span>{" "}
        categories
        {canManage && (
          <span className="ml-2 text-white/50">
            · drag <GripVertical className="inline h-3.5 w-3.5" /> to reorder
          </span>
        )}
      </p>
      {canManage && (
        <button
          type="button"
          onClick={() => addSection()}
          className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-2xl border-2 border-[#E5E5E5] bg-white px-5 text-sm font-extrabold uppercase tracking-wide text-[#3C3C3C] shadow-[0_6px_0_#D0D0D0] transition-transform active:translate-y-1 active:shadow-[0_2px_0_#D0D0D0]"
        >
          <Plus className="h-5 w-5" strokeWidth={2.5} aria-hidden />
          Add category
        </button>
      )}
    </div>
  );
};
